import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "aiStyleStepContainer"
};
const _hoisted_2 = {
  class: "titleText"
};
const _hoisted_3 = {
  class: "subtitleText"
};
const _hoisted_4 = {
  class: "modeSelector"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "modeCardCheck"
};
const _hoisted_7 = {
  class: "modeCardIconWrap"
};
const _hoisted_8 = {
  class: "modeTitle"
};
const _hoisted_9 = {
  class: "modeDesc"
};
const _hoisted_10 = {
  key: 0,
  class: "stepBlock"
};
const _hoisted_11 = {
  class: "stepBlockHeader"
};
const _hoisted_12 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_13 = {
  class: "stepBlockIcon"
};
const _hoisted_14 = {
  class: "stepBlockTitle"
};
const _hoisted_15 = {
  class: "stepBlockSubtitle"
};
const _hoisted_16 = {
  class: "carouselViewport"
};
const _hoisted_17 = {
  class: "templateCarousel",
  ref: "carousel"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0,
  class: "templateCheck"
};
const _hoisted_20 = {
  class: "templatePreview"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 1,
  class: "templatePlaceholder"
};
const _hoisted_23 = {
  class: "templateLabel"
};
const _hoisted_24 = {
  key: 1,
  class: "stepBlock"
};
const _hoisted_25 = {
  class: "stepBlockHeader"
};
const _hoisted_26 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_27 = {
  class: "stepBlockIcon"
};
const _hoisted_28 = {
  class: "stepBlockTitle"
};
const _hoisted_29 = {
  class: "stepBlockSubtitle"
};
const _hoisted_30 = {
  key: 0,
  class: "avatarBlockBody"
};
const _hoisted_31 = {
  class: "previewColumn"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  class: "controlsColumn"
};
const _hoisted_34 = {
  class: "controlLabel"
};
const _hoisted_35 = {
  class: "controlLabel"
};
const _hoisted_36 = {
  class: "controlLabel"
};
const _hoisted_37 = {
  key: 2,
  class: "stepBlock"
};
const _hoisted_38 = {
  class: "stepBlockHeader"
};
const _hoisted_39 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_40 = {
  class: "stepBlockIcon"
};
const _hoisted_41 = {
  class: "stepBlockTitle"
};
const _hoisted_42 = {
  class: "stepBlockSubtitle"
};
const _hoisted_43 = {
  class: "controlLabel"
};
const _hoisted_44 = {
  key: 3,
  class: "stepBlock"
};
const _hoisted_45 = {
  class: "stepBlockHeader"
};
const _hoisted_46 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_47 = {
  class: "stepBlockIcon"
};
const _hoisted_48 = {
  class: "stepBlockTitle"
};
const _hoisted_49 = {
  class: "stepBlockSubtitle"
};
const _hoisted_50 = {
  class: "stepBlock"
};
const _hoisted_51 = {
  class: "stepBlockHeader"
};
const _hoisted_52 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_53 = {
  class: "stepBlockIcon"
};
const _hoisted_54 = {
  class: "stepBlockTitle"
};
const _hoisted_55 = {
  class: "stepBlockSubtitle"
};
const _hoisted_56 = {
  class: "stepBlock"
};
const _hoisted_57 = {
  class: "stepBlockHeader"
};
const _hoisted_58 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_59 = {
  class: "stepBlockIcon"
};
const _hoisted_60 = {
  class: "stepBlockTitle"
};
const _hoisted_61 = {
  class: "stepBlockSubtitle"
};
const _hoisted_62 = {
  class: "stepBlock durationBlock"
};
const _hoisted_63 = {
  class: "stepBlockHeader"
};
const _hoisted_64 = {
  class: "stepBlockHeaderLeft"
};
const _hoisted_65 = {
  class: "stepBlockIcon"
};
const _hoisted_66 = {
  class: "stepBlockTitle"
};
const _hoisted_67 = {
  class: "stepBlockSubtitle"
};
const _hoisted_68 = {
  key: 0,
  class: "allowReorderRow"
};
const _hoisted_69 = {
  class: "stepBlock"
};
const _hoisted_70 = {
  class: "stepBlockHeaderLeft instructionsHead"
};
const _hoisted_71 = {
  class: "stepBlockIcon"
};
const _hoisted_72 = {
  class: "stepBlockTitle"
};
const _hoisted_73 = {
  class: "stepBlockSubtitle"
};
const _hoisted_74 = {
  class: "bottomLineButton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_ai_credits_tool_tip = _resolveComponent("ai-credits-tool-tip");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_select = _resolveComponent("w-select");
  const _component_VoiceSelectorModal = _resolveComponent("VoiceSelectorModal");
  const _component_w_checkbox = _resolveComponent("w-checkbox");
  const _component_w_input = _resolveComponent("w-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.title')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.subtitle')), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modeCards, mode => {
    return _openBlock(), _createElementBlock("div", {
      key: mode.value,
      class: _normalizeClass(["modeCard", {
        selected: _ctx.selectedLayout === mode.value
      }]),
      onClick: $event => _ctx.onSelectMode(mode.value)
    }, [_ctx.selectedLayout === mode.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_icon, {
      icon: "check"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createVNode(_component_icon, {
      icon: mode.icon,
      size: "large",
      color: "primary"
    }, null, 8, ["icon"])]), _createElementVNode("div", _hoisted_8, _toDisplayString(mode.title), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(mode.desc), 1)], 10, _hoisted_5);
  }), 128))]), _ctx.showExplainerBlock ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_icon, {
    icon: "movie-open-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.explainerBlockTitle')) + " ", 1), _createVNode(_component_ai_credits_tool_tip)]), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.explainerTemplateRequired')), 1)])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
    type: "button",
    class: "carouselNavButton carouselNavPrev",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.scrollCarousel(-1)),
    "aria-label": "Previous"
  }, [_createVNode(_component_icon, {
    icon: "chevron-left",
    size: "medium"
  })]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visualTemplates, tpl => {
    return _openBlock(), _createElementBlock("div", {
      key: tpl.key,
      class: _normalizeClass(["templateCard", {
        selected: _ctx.selectedTemplateKey === tpl.key
      }]),
      onClick: $event => _ctx.onTemplateSelect(tpl.key)
    }, [_ctx.selectedTemplateKey === tpl.key ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_icon, {
      icon: "check"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [tpl.videoUrl ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      src: tpl.videoUrl,
      class: "templateVideo",
      muted: "",
      loop: "",
      autoplay: "",
      playsinline: ""
    }, null, 8, _hoisted_21)) : (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_icon, {
      icon: "movie-open-outline",
      size: "huge",
      color: "light2"
    })]))]), _createElementVNode("div", _hoisted_23, _toDisplayString(tpl.label), 1)], 10, _hoisted_18);
  }), 128))], 512), _createElementVNode("button", {
    type: "button",
    class: "carouselNavButton carouselNavNext",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.scrollCarousel(1)),
    "aria-label": "Next"
  }, [_createVNode(_component_icon, {
    icon: "chevron-right",
    size: "medium"
  })])])])) : _createCommentVNode("", true), _ctx.showAvatarBlock ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_icon, {
    icon: "account-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_28, [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.avatarBlockTitle')) + " ", 1), _createVNode(_component_ai_credits_tool_tip)]), _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.avatarBlockSubtitle')), 1)])]), _createVNode(_component_el_switch, {
    modelValue: _ctx.useAvatar,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.useAvatar = $event),
    onChange: _ctx.onUseAvatarChange
  }, null, 8, ["modelValue", "onChange"])]), _ctx.useAvatar ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
    class: "previewFrame",
    style: _normalizeStyle(_ctx.previewFrameStyle)
  }, [_withDirectives(_createElementVNode("div", {
    class: "avatarStaticLayer",
    style: _normalizeStyle(_ctx.avatarStaticStyle)
  }, null, 4), [[_vShow, !_ctx.isPlayingAnim]]), _withDirectives(_createElementVNode("video", {
    class: "avatarAnimLayer",
    ref: "animVideo",
    src: _ctx.currentAvatarAnimUrl,
    muted: "",
    onEnded: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.stopAnim && _ctx.stopAnim(...args))
  }, null, 40, _hoisted_32), [[_vShow, _ctx.isPlayingAnim]])], 4), _createVNode(_component_standard_button, {
    outlined: true,
    class: "previewButton",
    onAction: _ctx.togglePreview
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: _ctx.isPlayingAnim ? 'stop' : 'play'
    }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.isPlayingAnim ? _ctx.$t('aiSpeachGenerator.styleStep.stopPreview') : _ctx.$t('aiSpeachGenerator.styleStep.preview')), 1)]),
    _: 1
  }, 8, ["onAction"])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.avatarLabel')), 1), _createVNode(_component_w_select, {
    options: _ctx.avatarOptions,
    value: _ctx.selectedAvatar,
    size: "large",
    "popper-class": "aiStylePickerDropdown",
    onChange: _ctx.onAvatarChange
  }, null, 8, ["options", "value", "onChange"]), _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.backgroundLabel')), 1), _createVNode(_component_w_select, {
    options: _ctx.backgroundOptions,
    value: _ctx.selectedBackground,
    size: "large",
    "popper-class": "aiStylePickerDropdown",
    onChange: _ctx.onBackgroundChange
  }, null, 8, ["options", "value", "onChange"]), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.voiceLabel')), 1), _createElementVNode("div", {
    class: "voiceSelectWrap",
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    (...args) => _ctx.openVoiceModal && _ctx.openVoiceModal(...args))
  }, [_createVNode(_component_w_select, {
    options: _ctx.voiceDisplayOptions,
    value: _ctx.selectedVoice,
    size: "large",
    "popper-class": "aiStylePickerDropdown",
    class: "voiceSelect"
  }, null, 8, ["options", "value"]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "voiceSelectOverlay"
  }, null, -1))])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.showVoiceOnlyBlock ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_icon, {
    icon: "microphone-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.voiceBlockTitle')), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.voiceBlockSubtitle')), 1)])])]), _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.voiceLabel')), 1), _createElementVNode("div", {
    class: "voiceSelectWrap",
    onClick: _cache[5] || (_cache[5] =
    //@ts-ignore
    (...args) => _ctx.openVoiceModal && _ctx.openVoiceModal(...args))
  }, [_createVNode(_component_w_select, {
    options: _ctx.voiceDisplayOptions,
    value: _ctx.selectedVoice,
    size: "large",
    "popper-class": "aiStylePickerDropdown",
    class: "voiceSelect"
  }, null, 8, ["options", "value"]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "voiceSelectOverlay"
  }, null, -1))])])) : _createCommentVNode("", true), _createVNode(_component_VoiceSelectorModal, {
    active: _ctx.voiceModalOpen,
    voice: _ctx.selectedVoice,
    gender: _ctx.voiceModalGender,
    "advanced-tts-enabled": _ctx.advancedTtsEnabled,
    onValidate: _ctx.onVoiceModalValidate,
    onClose: _cache[6] || (_cache[6] = $event => _ctx.voiceModalOpen = false)
  }, null, 8, ["active", "voice", "gender", "advanced-tts-enabled", "onValidate"]), _ctx.showImageStyleBlock ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_icon, {
    icon: "image-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.imageStyleBlockTitle')), 1), _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.imageStyleBlockSubtitle')), 1)])])]), _createVNode(_component_w_select, {
    options: _ctx.imageStyleOptions,
    value: _ctx.selectedImageStyle,
    size: "large",
    onChange: _ctx.onImageStyleChange
  }, null, 8, ["options", "value", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createVNode(_component_icon, {
    icon: "help-circle-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.quizBlockTitle')), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.quizBlockSubtitle')), 1)])]), _createVNode(_component_el_switch, {
    modelValue: _ctx.quizEnabled,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.quizEnabled = $event)
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_icon, {
    icon: "tooltip-text-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.annotationsBlockTitle')), 1), _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.annotationsBlockSubtitle')), 1)])]), _createVNode(_component_el_switch, {
    modelValue: _ctx.annotationsEnabled,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.annotationsEnabled = $event)
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createVNode(_component_icon, {
    icon: "clock-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.duration')), 1), _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.durationSubtitle')), 1)])]), _createVNode(_component_w_select, {
    class: "durationSelect",
    options: _ctx.listOfDuration,
    value: _ctx.durationSelected,
    size: "large",
    clearable: false,
    onChange: _ctx.onDurationSelected
  }, null, 8, ["options", "value", "onChange"])]), _ctx.isPreserveDocument ? (_openBlock(), _createElementBlock("div", _hoisted_68, [_createVNode(_component_w_checkbox, {
    class: "checkBoxReorder",
    "model-value": _ctx.allowReorder,
    "onUpdate:modelValue": _ctx.onAllowReorderChange
  }, null, 8, ["model-value", "onUpdate:modelValue"]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.allowReorder')), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createVNode(_component_icon, {
    icon: "text-box-outline",
    size: "large",
    color: "dark"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.specificInstruction')), 1), _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.specificInstructionSubtitle')), 1)])]), _createVNode(_component_w_input, {
    class: "specificInstructionTextArea",
    value: _ctx.specificPrompt,
    type: "textarea",
    placeholder: _ctx.$t('aiSpeachGenerator.options.instructionsPlaceholder'),
    onChange: _ctx.onSpecificPromptChange
  }, null, 8, ["value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_74, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.onBack
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "arrow-left"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.back')), 1)]),
    _: 1
  }, 8, ["onAction"]), _createVNode(_component_standard_button, {
    disabled: !_ctx.canValidate,
    onAction: _ctx.onValidate
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.styleStep.generateButton')) + " ", 1), _createVNode(_component_icon, {
      icon: "arrow-right"
    })]),
    _: 1
  }, 8, ["disabled", "onAction"])])]);
}